import React from 'react';
import { Chart as ChartJS } from 'chart.js/auto'
import { Bar }            from 'react-chartjs-2'
const BarChart = ({labels,values}) => {
console.log("=====labels=====",labels)
  // Your chart data and options
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Sales',
        data: values,
       backgroundColor: '#00A850',
            borderColor: '#00A850',
          borderWidth: 0.1,
            barThickness: 13,
            borderRadius: 12      },
    ],
  };

  const options = {
    scales: {
      y: {
        type: 'linear', // specify the scale type explicitly
        beginAtZero: true,
        ticks: {
          // Use callback function to prepend dollar sign to each tick value
          callback: function (value, index, values) {
            return '$' + value;
          },
        },
      },
    },
    plugins: {
      title: {
        display: true,
        text: 'Statistics and Revenue', // Title text
        font: {
          size: 20, // Title font size
        },
      },
      tooltip: {
        callbacks: {
          // Use callback function to prepend dollar sign to each tooltip label
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += '$' + context.parsed.y.toFixed(2); // Append dollar sign
            }
            return label;
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
